import { threadCopy } from '@/copy'

/** Collapses runs of whitespace (including newlines from root previews) so
 *  the label renders on a single line. */
function normalizeLabel(label?: string | null): string {
  return (label ?? '').replace(/\s+/g, ' ').trim()
}

/** A label made only of dots/ellipses carries nothing worth showing. */
function hasContent(label: string): boolean {
  return /[^.…\s]/.test(label)
}

/** The first candidate with real content; otherwise the fallback. The label is passed through at full length; the field's
 *  placeholder truncates it. */
function composerLabel(
  candidates: (string | null | undefined)[],
  fallback: string,
): string {
  return candidates.map(normalizeLabel).find(hasContent) ?? fallback
}

/** The thread reply composer's destination: the thread title, else its root
 *  preview (e.g. a freshly created thread whose title is still `''`). */
export function threadComposerLabel(
  title?: string | null,
  rootPreview?: string | null,
): string {
  return threadCopy.composer.newMessageIn(
    composerLabel([title, rootPreview], threadCopy.composer.thisThread),
  )
}

/** The topic composer's destination; it starts a new thread. */
export function topicComposerLabel(topicName?: string | null): string {
  return threadCopy.composer.newThreadIn(
    composerLabel([topicName], threadCopy.composer.thisTopic),
  )
}
